export const setToken = (token: string) => {
  localStorage.setItem("token", token);
};
